/**
 * @external https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
 * @external https://caniuse.com/?search=localstorage
 * @description Little helper for interacting with the browsers localStorage.
 * We implicitly assume its available and we provide these helpers to allow
 * for versioning of the surveys & any answers.
 */

import { IS_BROWSER } from '@src/config/settings';

/**
 * @name getLocalStorageValue
 * @description tbd...
 */
export function getLocalStorageValue(name: string, version: number) {
  if (!IS_BROWSER) throw new Error('LocalStorage is not available in Node.js');

  const defaultSurvey = { data: {}, name, version };
  const defaultValue = JSON.stringify(defaultSurvey);

  const survey = window.localStorage.getItem(name) ?? defaultValue;
  const json = JSON.parse(survey);

  const { version: ver } = json;
  let { data = {} } = json;

  // If the version is outdated, reset the answers
  if (version !== ver) data = {};

  return {
    data,
    name,
    version
  };
}

/**
 * @name setLocalStorageValue
 * @description tbd...
 */
export function setLocalStorageValue(name: string, version: number, data: any) {
  if (!IS_BROWSER) throw new Error('LocalStorage is not available in Node.js');

  const json = { data, name, version };
  const str = JSON.stringify(json);

  window.localStorage.setItem(name, str);
}
